<script>
import isMobile from 'ismobilejs'
import { getLocalStorage } from '@/helpers/site'
export default {
  data() {
    return {
      isLandscape: false
    }
  },
  computed: {},
  mounted() {
    // this.checkIsMobile()
    this.portrait = window.matchMedia('(orientation: portrait)')
    this.isLandscape = (window.innerWidth / window.innerHeight > 1.5) && isMobile().any

    this.portrait.addEventListener('change', this.onPortrait)
    window.onresize = this.onPortrait
  },
  destroyed() {
    this.portrait.removeEventListener('change', this.onPortrait)
  },
  methods: {
    onPortrait() {
      let checkPortrait = (window.innerWidth / window.innerHeight > 1.5)
      this.isLandscape = checkPortrait && isMobile().any
    },
    checkIsMobile() {
      const onMobile = isMobile().any
      if (!onMobile) {
        const onPC = getLocalStorage('onPC')
        if (!onPC) {
          this.$router.push({ name: 'pc-screen' })
        }
      }
    },
  },
}
</script>

<template>
  <div id="app">
    <div class="layout-background">
      <s-side-left></s-side-left>
      <div class="layout-center"></div>
      <s-side-right></s-side-right>
    </div>
    <div id="main">
      <s-modal-portrait-mode :visible="isLandscape"></s-modal-portrait-mode>
      <router-view />
    </div>
    <s-footer></s-footer>
    <div class="main-container"></div>
  </div>
</template>

<style lang="scss">
@import 'main.scss';
</style>
